var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "23", height: "23", viewBox: "0 0 23 23", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { opacity: ".53" },
      React.createElement(
        "g",
        { opacity: ".995", fill: "#000", fillRule: "nonzero" },
        React.createElement("path", { d: "M22.614 3.648l-.07-.072a.715.715 0 0 0-.522-.24H5.687l-.07-.41A2.255 2.255 0 0 0 3.39 1H1.734a.678.678 0 0 0-.687.698c0 .385.308.698.687.698h1.68a.87.87 0 0 1 .853.723l1.42 8.691a.46.46 0 0 0 .048.193l.237 1.493c.213 1.324 1.373 2.311 2.675 2.311H19.63a.678.678 0 0 0 .687-.698.693.693 0 0 0-.687-.698H8.623a1.311 1.311 0 0 1-1.302-1.108l-.142-.794h12.784c.142.024.26.024.379-.049a.761.761 0 0 0 .355-.457l1.988-7.729c.095-.216.048-.433-.07-.626zM21.17 4.78l-1.657 6.356H6.966L5.948 4.78H21.17z", stroke: "#000", strokeWidth: ".5" }),
        React.createElement("path", { d: "M16.507 17C15.126 17 14 18.145 14 19.55c0 1.405 1.1 2.576 2.507 2.576 1.408 0 2.508-1.145 2.508-2.55 0-1.405-1.126-2.576-2.508-2.576zm-.025 1.535c.563 0 .998.443.998 1.015 0 .546-.46 1.015-.998 1.015-.537 0-.998-.469-.998-1.015-.026-.546.435-1.015.998-1.015zM9.507 17C8.126 17 7 18.145 7 19.55c0 1.405 1.1 2.576 2.507 2.576 1.408 0 2.508-1.145 2.508-2.55 0-1.405-1.126-2.576-2.508-2.576zm-.025 1.535c.563 0 .998.443.998 1.015 0 .546-.46 1.015-.998 1.015-.537 0-.998-.469-.998-1.015-.026-.546.435-1.015.998-1.015z" })
      )
    )
  );
});